export default __webpack_public_path__ + "static/media/Malaysia.79bb4ede.svg";